<template>
  <portlet
      :actionsBlock="false"
      :icon="'fal fa-business-time'"
      v-bind:class="showAnimation ? 'highlight-portlet' : ''"
      :title="$t('breaks.manage') + ': ' + shift.name + getShiftTimes"
  >
    <template slot="portletBody">
      <div v-if="editingBreaks.length" class="breaks-table ve-table ve-table-border-around" height="400" width="100">
        <div class="ve-table-container" style="max-height: 400px; height: 350px;">

          <table class="ve-table-content ve-table-border-x">
            <thead class="ve-table-fixed-header ve-table-header">
            <tr class="ve-table-header-tr">
              <th class="ve-table-header-th">
                {{ $t('breaks.table.fromTime') }}
              </th>
              <th class="ve-table-header-th">
                {{ $t('breaks.table.endTime') }}
              </th>
              <th class="ve-table-header-th">
                {{ $t('breaks.table.duration') }}
              </th>
              <th class="ve-table-header-th">
                {{ $t('breaks.table.delete') }}
              </th>
            </tr>

            </thead>
            <tbody class="ve-table-body ve-table-stripe ve-table-row-hover ve-table-row-highlight">
            <tr style="height: 0px;">
              <td style="padding: 0px; border: 0px; height: 0px;"></td>
              <td style="padding: 0px; border: 0px; height: 0px;"></td>
              <td style="padding: 0px; border: 0px; height: 0px;"></td>
              <td style="padding: 0px; border: 0px; height: 0px;"></td>
            </tr>
            <tr :key="'break-' +index" v-for="(editingBreak, index) in editingBreaks" class="ve-table-body-tr">
              <template v-if="editingBreak">
                <td class="ve-table-body-td">
                  <input
                      id="shift-start-time"
                      type="time"
                      class="form-control"
                      v-model="editingBreak.startTime"
                      @change="formatStartTime(index, editingBreak.startTime)"
                  />
                </td>
                <td class="ve-table-body-td">
                  <input
                      id="shift-start-time"
                      type="time"
                      class="form-control"
                      v-model="editingBreak.endTime"
                      @change="formatEndTime(index, editingBreak.endTime)"
                  />
                </td>
                <td class="ve-table-body-td">
                  {{ getDuration(editingBreak.start, editingBreak.end) }}
                </td>
                <td class="ve-table-body-td">
                  <button @click="deleteBreak(index)"
                          class="table-button btn btn-danger btn-block">{{ $t('ui.delete')}}</button>
                </td>
              </template>

            </tr>
            </tbody>
          </table>
        </div>

      </div>
      <div v-else>{{ $t('breaks.table.noRecords') }}</div>
      <div class="breaks-form-buttons">
        <div class="row justify-content-end">
          <div class="col-12 col-sm-auto">
            <button id="add-break-button" @click="addBreak()" class="mt-2 btn btn-secondary">{{
                $t('breaks.addBreak')
              }}
            </button>
          </div>
          <div class="col-12 col-sm-auto">
            <button id="save-break-button" @click="dismiss()" class="mt-2 btn btn-primary">{{ $t('ui.cancel') }}</button>
          </div>
          <div class="col-12 col-sm-auto">
            <button id="save-break-button" @click="save()" class="mt-2 btn btn-primary">{{ $t('ui.save') }}</button>
          </div>
        </div>
      </div>
    </template>
  </portlet>
</template>

<script>
import {mapGetters} from "vuex";
import 'verte/dist/verte.css';
import timeCalc from '../../mixins/timeCalc';

export default {
  name: "BreaksForm",
  props: ['shift'],
  mixins: [timeCalc],
  data() {
    return {
      editingBreaks: []
    }
  },
  components: {},
  computed: {
    ...mapGetters('breaks', ['getBreaks']),
    ...mapGetters('users',['getClaims']),
    ...mapGetters('workflows', ['getWorkflows']),
    getBreaksOfShift() {
      return _.filter(this.getBreaks.breaks, breakOfCompany => {
        return breakOfCompany.shifts.indexOf(this.shift.id) > -1;
      })
    },
    getShiftTimes() {
      const endTime = moment().set({hour: this.shift.endTime.split(':')[0], minute:this.shift.endTime.split(':')[1]}).add(1, 'minute').format('HH:mm');
      return this.shift ? ` (${this.shift.startTime} - ${endTime})` : '';
    }
  },
  methods: {
    deleteBreak(index) {
      this.editingBreaks.splice(index, 1)
    },
    getDuration(start, end) {
      const startTime = moment().set(start);
      let endTime = moment().set(end);
      if (endTime.isSameOrBefore(startTime)) {
        endTime.add(1, 'day');
      }
      endTime.add(1, 'minute')
      let converted = this.convertMs(endTime.diff(startTime));
      return `${converted.hrs}:${converted.min}:${converted.sec}`;

    },
    formatStartTime(index, startTime) {
      this.editingBreaks[index].start = {
        hour: startTime.split(':')[0],
        minute: startTime.split(':')[1],
      }
    },
    formatEndTime(index, endTime) {
      const preEndTimeObject = {
        hour: endTime.split(':')[0],
        minute: endTime.split(':')[1],
      }
      const parsedEndTime = moment().set(preEndTimeObject).subtract(1, 'minute').format('HH:mm');
      this.editingBreaks[index].end = {
        hour: parsedEndTime.split(':')[0],
        minute: parsedEndTime.split(':')[1],
      }
    },
    addBreak() {
      this.editingBreaks.push({
        "endTime": "00:00",
        "startTime": "00:00",
        "end": {
          "hour": 23,
          "minute": 59
        },
        "shifts": [
          this.shift.id
        ],
        "start": {
          "hour": 0,
          "minute": 0
        },
        "workflows": []
      })
    },
    dismiss() {
      this.editingBreaks = [];
      this.$emit('editBreaksDismissed')
    },
    async save() {
      const currentDoc = this.getBreaks;
      let newDoc = currentDoc;
      // Remove ALL breaks of the current shift
      newDoc.breaks = _.filter(newDoc.breaks, currentBreak => {
        return currentBreak.shifts.indexOf(this.shift.id) === -1;
      })
      // Now add the breaks again, but from the edited source.
      for(let i = 0; i < this.editingBreaks.length; i++) {
        let breakToAdd = this.editingBreaks[i];
        delete breakToAdd.startTime;
        delete breakToAdd.endTime;
        newDoc.breaks.push(breakToAdd)
      }
      newDoc.companyId = this.getClaims.companyId
      await this.$store.dispatch('breaks/patch', newDoc);
      this.swalToastSuccess(this.$t("ui.saved"));
      this.dismiss();
    }
  },
  created() {
    this.showAnimation = true;
    setTimeout(() => { this.showAnimation = false; } , 1000)
    this.editingBreaks = _.map(this.getBreaksOfShift, breakItem => {
      breakItem.startTime = moment().set(breakItem.start).format('HH:mm');
      breakItem.endTime = moment().set(breakItem.end).add(1, 'minute').format('HH:mm');
      return breakItem;
    })
  },
  watch: {
    'shift': {
      deep: true,
      handler(newV, oldV) {
        this.showAnimation = true;
        setTimeout(() => { this.showAnimation = false; } , 1000)
        this.editingBreaks = _.map(this.getBreaksOfShift, breakItem => {
          breakItem.startTime = moment().set(breakItem.start).format('HH:mm');
          breakItem.endTime = moment().set(breakItem.end).add(1, 'minute').format('HH:mm');
          return breakItem;
        })
      }
    }
  }
}
</script>

<style scoped>

.breaks-form-buttons {
  margin-top: 16px;
}
#save-shift-button, #dismiss-shift-changes-button {
  width: 100%;
}


.highlight-portlet {
  animation: pulse; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 0.5s; /* don't forget to set a duration! */
}

.vertical-aligned-checkbox {
  display: grid;
  align-items: center;
}

.disabled-times {
  display: block;
  width: fit-content;
}
</style>
<style lang="scss">

@import "@/assets/scss/plugins/veTable.scss";

.verte__menu-origin {
  border: 1px solid #dbdbdb;
}

.verte__icon {
  cursor: pointer;
}
</style>